import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  NgModule,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';

import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';

import {
  DatePipe,
  I18nPluralPipe,
  JsonPipe,
  registerLocaleData,
} from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { routes } from './app.routes';
import {
  CalendarA11y,
  CalendarDateFormatter,
  CalendarEventTitleFormatter,
  CalendarUtils,
  DateAdapter,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FlatpickrDefaults } from 'angularx-flatpickr';
import { CustomDateFormatter } from './core/pipe/custom-date-formatter';
import { ViewerBackService } from './viewer/core/services/viewer-back.service';
import { PreloadPortalStrategy } from './core/config/preload-portal.strategy';
import localeEsPY from '@angular/common/locales/es-PY';
import { environment } from '../environments/environment';

registerLocaleData(localeEsPY);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-PY' }, // Configura Español (Paraguay)
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withEnabledBlockingInitialNavigation(),
      // Baja en segundo plano las pantallas del portal (ver
      // PreloadPortalStrategy). Los visores quedan afuera a proposito.
      withPreloading(PreloadPortalStrategy),
      withHashLocation()
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    // El "volver" del visor cuenta las navegaciones para saber si hay vista
    // anterior, así que tiene que existir desde la primera, no desde que el
    // visor lo inyecta.
    provideAppInitializer(() => {
      inject(ViewerBackService);
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
    {
      provide: DateAdapter,
      useFactory: adapterFactory,
    },
    CalendarDateFormatter,
    CalendarUtils,
    CalendarA11y,
    I18nPluralPipe,
    CalendarEventTitleFormatter,
    FlatpickrDefaults,
    DatePipe,
    NgbCarouselConfig,
    NgModule,
    JsonPipe,
  ],
};
